import React, { useState, useEffect, useRef } from "react";
import { CryptoType, Coin } from "../interface";
import { formatCurrency } from "../utils/format-utils";
import CloseIcon from "@mui/icons-material/Close";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";

type CryptoCardProps = {
  item: Coin;
  onClose: (id: string) => void;
  onLoad: () => void;
};

export const SelectedCoinCard: React.FC<CryptoCardProps> = ({
  item,
  onClose,
  onLoad,
}) => {
  const handleLinkClick = async (url: string) => {
    if (url !== "") {
      window.open(url, "_blank");
    }
  };

  useEffect(() => {
    if (item?.platforms && item.platforms.length > 0) {
      onLoad();
    }
  }, [item, onLoad]);

  return (
    <>
      <style>
        {`
          .hot-name-${item.id}::after {
              content: "${item.symbol.toUpperCase()}";
          }
        `}
      </style>
      <div className={"nft selected-nft hot-name-" + item.id + " hot-badge"}>
        <div className="main">
          <CloseIcon
            className="absolute text-white left-[10px] left-[10px] cursor-pointer"
            name="Close"
            onClick={() => onClose(item.id)}
          />
          <img className="tokenImage" src={item.thumb} alt={item.name} />
          <h2>{item.platforms && formatCurrency(item.platforms[0].price)}</h2>
          <hr />
          {item.platforms &&
            item?.platforms.map((pf, index) => {
              return (
                <div
                  key={index}
                  className="flex justify-between items-center"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLinkClick(pf.url);
                  }}
                >
                  <div className="creator">
                    <div className="wrapper">
                      <img
                        src={
                          "/images/exchange/" + pf.name.toLowerCase() + ".png"
                        }
                        alt={pf.name}
                      />
                    </div>
                    <p>
                      <ins>{pf.name}</ins>
                    </p>
                  </div>
                  <p>{formatCurrency(pf.price)}</p>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};
